// src/WorldRecords.js

import React, { useState } from 'react';
import './WorldRecords.css';

const worldRecordsData = {
    "Highest Mountain": {
      name: "Mount Everest",
      details: "Mount Everest is the highest mountain in the world.",
      place: "Nepal/Tibet",
      history: "First summited by Sir Edmund Hillary and Tenzing Norgay in 1953.",
      significance: "It stands at 8,848 meters (29,029 feet) above sea level."
    },
    "Lowest Point on Land": {
      name: "Dead Sea",
      details: "The Dead Sea is the lowest point on Earth's land surface.",
      place: "Jordan/Israel",
      history: "Known for its extremely high salinity.",
      significance: "It is 430 meters (1,412 feet) below sea level."
    },
    "Longest River": {
      name: "Nile River",
      details: "The Nile River is the longest river in the world.",
      place: "Northeast Africa",
      history: "Has been a vital waterway for civilizations for thousands of years.",
      significance: "It flows for about 6,650 kilometers (4,130 miles)."
    },
    "Smallest Country": {
      name: "Vatican City",
      details: "Vatican City is the smallest country in the world.",
      place: "Rome, Italy",
      history: "It is the spiritual and administrative center of the Roman Catholic Church.",
      significance: "It covers an area of 44 hectares (110 acres)."
    },
    "Shortest River": {
      name: "Roe River",
      details: "The Roe River is the shortest river in the world.",
      place: "Montana, USA",
      history: "It was recognized by the Guinness World Records in 1989.",
      significance: "It is only 61 meters (200 feet) long."
    },
    "Easiest Language to Learn": {
      name: "Esperanto",
      details: "Esperanto is considered one of the easiest languages to learn.",
      place: "International",
      history: "Created by L. L. Zamenhof in 1887.",
      significance: "It has a simple grammar and vocabulary designed for easy learning."
    },
    "Hardest Material": {
      name: "Diamond",
      details: "Diamond is the hardest natural material.",
      place: "Worldwide",
      history: "Used in various applications due to its hardness.",
      significance: "Has a rating of 10 on the Mohs hardness scale."
    },
    "Highest Waterfall": {
      name: "Angel Falls",
      details: "Angel Falls is the highest waterfall in the world.",
      place: "Venezuela",
      history: "Named after the American aviator Jimmie Angel.",
      significance: "It drops 979 meters (3,212 feet)."
    },
    "Lowest Temperature Recorded": {
      name: "Vostok Station",
      details: "The lowest temperature ever recorded on Earth.",
      place: "Antarctica",
      history: "Recorded on July 21, 1983.",
      significance: "The temperature was -89.2°C (-128.6°F)."
    },
    "Longest Wall": {
      name: "Great Wall of China",
      details: "The Great Wall of China is the longest wall in the world.",
      place: "China",
      history: "Built over several dynasties to protect against invasions.",
      significance: "It stretches over 13,000 miles (21,196 kilometers)."
    },
    "Deepest Ocean Trench": {
      name: "Mariana Trench",
      details: "The Mariana Trench is the deepest ocean trench in the world.",
      place: "Pacific Ocean",
      history: "First explored by Jacques Piccard and Don Walsh in 1960.",
      significance: "It reaches a depth of about 10,994 meters (36,070 feet)."
    },
    "Largest Desert": {
      name: "Antarctic Desert",
      details: "The Antarctic Desert is the largest desert in the world.",
      place: "Antarctica",
      history: "Covers the entire continent of Antarctica.",
      significance: "It covers an area of about 14 million square kilometers (5.4 million square miles)."
    },
    "Longest Cave System": {
      name: "Mammoth Cave",
      details: "Mammoth Cave is the longest cave system in the world.",
      place: "Kentucky, USA",
      history: "Explored and mapped for over a century.",
      significance: "It has more than 400 miles (640 kilometers) of explored passages."
    },
    "Oldest Tree": {
      name: "Methuselah",
      details: "Methuselah is the oldest tree in the world.",
      place: "California, USA",
      history: "Estimated to be over 4,800 years old.",
      significance: "It is a Great Basin bristlecone pine tree."
    },
    "Largest Coral Reef": {
      name: "Great Barrier Reef",
      details: "The Great Barrier Reef is the largest coral reef system in the world.",
      place: "Australia",
      history: "Known for its rich biodiversity.",
      significance: "It spans over 2,300 kilometers (1,430 miles)."
    },
    "Highest Building": {
      name: "Burj Khalifa",
      details: "Burj Khalifa is the highest building in the world.",
      place: "Dubai, UAE",
      history: "Completed in 2010.",
      significance: "It stands at 828 meters (2,717 feet) tall."
    },
    "Oldest City": {
      name: "Jericho",
      details: "Jericho is considered the oldest continuously inhabited city in the world.",
      place: "West Bank",
      history: "Dates back to 9000 BCE.",
      significance: "Known for its ancient ruins and historical significance."
    },
    "Largest Ocean": {
      name: "Pacific Ocean",
      details: "The Pacific Ocean is the largest ocean in the world.",
      place: "Pacific Ocean",
      history: "Covers more than 63 million square miles.",
      significance: "It covers more than 30% of the Earth's surface."
    },
    "Longest Mountain Range": {
      name: "Andes Mountains",
      details: "The Andes Mountains is the longest mountain range in the world.",
      place: "South America",
      history: "Stretches along the western coast of South America.",
      significance: "It is about 7,000 kilometers (4,350 miles) long."
    },
    "Highest Volcano": {
      name: "Ojos del Salado",
      details: "Ojos del Salado is the highest volcano in the world.",
      place: "Chile/Argentina",
      history: "Last erupted about 1,300 years ago.",
      significance: "It stands at 6,893 meters (22,615 feet)."
    },
    "Largest Island": {
      name: "Greenland",
      details: "Greenland is the largest island in the world.",
      place: "Denmark",
      history: "Known for its vast ice sheet.",
      significance: "Covers an area of about 2,166,086 square kilometers (836,331 square miles)."
    },
    "Longest Road": {
      name: "Pan-American Highway",
      details: "The Pan-American Highway is the longest road in the world.",
      place: "North and South America",
      history: "Stretches from Alaska to Argentina.",
      significance: "It is about 30,000 kilometers (19,000 miles) long."
    },
    "Largest Lake": {
      name: "Caspian Sea",
      details: "The Caspian Sea is the largest lake in the world.",
      place: "Asia",
      history: "Contains brackish water.",
      significance: "Covers an area of about 371,000 square kilometers (143,000 square miles)."
    },
    "Longest Bridge": {
      name: "Danyang-Kunshan Grand Bridge",
      details: "The Danyang-Kunshan Grand Bridge is the longest bridge in the world.",
      place: "China",
      history: "Completed in 2010.",
      significance: "It is 164.8 kilometers (102.4 miles) long."
    },
    "Oldest University": {
      name: "University of al-Qarawiyyin",
      details: "The University of al-Qarawiyyin is the oldest existing, continually operating higher educational institution.",
      place: "Fez, Morocco",
      history: "Founded in 859 AD.",
      significance: "Recognized by UNESCO and Guinness World Records."
    },
    "Largest Forest": {
      name: "Amazon Rainforest",
      details: "The Amazon Rainforest is the largest forest in the world.",
      place: "South America",
      history: "Covers nine countries in South America.",
      significance: "It spans about 5.5 million square kilometers (2.1 million square miles)."
    },
    "Longest Railway": {
      name: "Trans-Siberian Railway",
      details: "The Trans-Siberian Railway is the longest railway in the world.",
      place: "Russia",
      history: "Connects Moscow to Vladivostok.",
      significance: "It is about 9,289 kilometers (5,772 miles) long."
    },
       
        "Highest Mountain in India": {
          name: "Kangchenjunga",
          details: "Kangchenjunga is the highest mountain in India and the third highest in the world.",
          place: "Sikkim-Nepal border",
          history: "First climbed by Joe Brown and George Band in 1955.",
          significance: "It stands at 8,586 meters (28,169 feet) above sea level."
        },
        "Largest River Island": {
          name: "Majuli",
          details: "Majuli is the largest river island in the world.",
          place: "Brahmaputra River, Assam",
          history: "It has a rich cultural heritage and is home to many tribal communities.",
          significance: "Covers an area of about 880 square kilometers (340 square miles)."
        },
        "Largest Salt Desert": {
          name: "Rann of Kutch",
          details: "The Rann of Kutch is the largest salt desert in the world.",
          place: "Gujarat",
          history: "Known for its white salt desert sands.",
          significance: "Covers an area of about 10,000 square kilometers (3,800 square miles)."
        },
        "Oldest Civilization in India": {
          name: "Indus Valley Civilization",
          details: "The Indus Valley Civilization is one of the oldest civilizations in the world.",
          place: "Northwestern regions of South Asia",
          history: "Flourished around 2500 BCE to 1900 BCE.",
          significance: "Known for its advanced urban planning, architecture, and social organization."
        },
        "Highest Rail Bridge": {
          name: "Chenab Bridge",
          details: "The Chenab Bridge is the highest rail bridge in the world.",
          place: "Jammu and Kashmir",
          history: "Constructed as part of the Udhampur-Srinagar-Baramulla rail link project.",
          significance: "Stands at 359 meters (1,178 feet) above the river bed."
        },
        "Largest Producer of Milk": {
          name: "India",
          details: "India is the largest producer of milk in the world.",
          place: "Nationwide",
          history: "Achieved through extensive dairy farming and the White Revolution.",
          significance: "Produces over 187 million metric tons of milk annually."
        },
        "Largest Film Industry": {
          name: "Bollywood",
          details: "Bollywood is the largest film industry in the world by the number of films produced.",
          place: "Mumbai",
          history: "Produces over 1,800 films annually.",
          significance: "Known for its vibrant music and dance sequences."
        },
        "Largest Banyan Tree": {
          name: "The Great Banyan",
          details: "The Great Banyan is the largest banyan tree in the world.",
          place: "Acharya Jagadish Chandra Bose Indian Botanic Garden, West Bengal",
          history: "Over 250 years old.",
          significance: "Covers an area of about 3.5 acres."
        },
        "Largest Cricket Stadium": {
          name: "Narendra Modi Stadium",
          details: "Narendra Modi Stadium is the largest cricket stadium in the world.",
          place: "Ahmedabad, Gujarat",
          history: "Renovated and reopened in 2020.",
          significance: "Has a seating capacity of 132,000 spectators."
        },
        "Oldest City in India": {
          name: "Varanasi",
          details: "Varanasi is one of the oldest continuously inhabited cities in the world.",
          place: "Uttar Pradesh",
          history: "Dates back to at least the 11th century BCE.",
          significance: "Known for its religious and cultural heritage, and as a major center of pilgrimage."
        },
      
                 "Oldest Known Civilization": {
              name: "Sumerians",
              details: "The Sumerians are considered the oldest known civilization in the world.",
              place: "Mesopotamia (modern-day Iraq)",
              history: "Developed around 4500 BCE.",
              significance: "Known for inventing the first form of writing, cuneiform."
            },
            "Oldest Written Law Code": {
              name: "Code of Ur-Nammu",
              details: "The Code of Ur-Nammu is the oldest known law code.",
              place: "Sumer (modern-day Iraq)",
              history: "Created around 2100-2050 BCE.",
              significance: "Preceded the more famous Code of Hammurabi."
            },
            "Oldest Surviving Literature": {
              name: "Epic of Gilgamesh",
              details: "The Epic of Gilgamesh is one of the oldest surviving works of literature.",
              place: "Mesopotamia (modern-day Iraq)",
              history: "Written around 2100 BCE.",
              significance: "Tells the story of the hero Gilgamesh and his quest for immortality."
            },
            "Oldest Known City": {
              name: "Jericho",
              details: "Jericho is considered the oldest known city in the world.",
              place: "West Bank",
              history: "Dates back to around 9000 BCE.",
              significance: "One of the earliest urban settlements."
            },
            "Oldest Known Pyramid": {
              name: "Step Pyramid of Djoser",
              details: "The Step Pyramid of Djoser is the oldest known pyramid in Egypt.",
              place: "Saqqara, Egypt",
              history: "Built during the 27th century BCE.",
              significance: "Designed by the architect Imhotep."
            },
            "Oldest Known Shipwreck": {
              name: "Uluburun Shipwreck",
              details: "The Uluburun Shipwreck is the oldest known shipwreck in the world.",
              place: "Near Kaş, Turkey",
              history: "Dated to around 1300 BCE.",
              significance: "Discovered in 1982, it provides valuable insights into ancient trade."
            },
            "Oldest Known Coin": {
              name: "Lydia Lion",
              details: "The Lydia Lion is the oldest known coin in the world.",
              place: "Lydia (modern-day Turkey)",
              history: "Created around 600 BCE.",
              significance: "Made of electrum, a naturally occurring alloy of gold and silver."
            },
            "Oldest Known Mummy": {
              name: "Ötzi the Iceman",
              details: "Ötzi the Iceman is the oldest known natural mummy.",
              place: "Ötztal Alps, Italy/Austria",
              history: "Died around 3300 BCE.",
              significance: "Discovered in 1991, he provides valuable information about Copper Age Europeans."
            },
            "Oldest Known Musical Instrument": {
              name: "Divje Babe Flute",
              details: "The Divje Babe Flute is the oldest known musical instrument.",
              place: "Slovenia",
              history: "Estimated to be around 43,000 years old.",
              significance: "Made from the femur of a cave bear."
            },
            "Oldest Known Painting": {
              name: "Cave of El Castillo",
              details: "The Cave of El Castillo contains the oldest known painting in the world.",
              place: "Spain",
              history: "Dated to around 40,000 years ago.",
              significance: "Features hand stencils and red disks."
            },
          
          
   
  // Add more records as needed
};

const WorldRecords = () => {
  const [selectedRecord, setSelectedRecord] = useState('Highest Mountain');
  const [readAloud, setReadAloud] = useState(false);

  const handleRecordChange = (e) => {
    setSelectedRecord(e.target.value);
  };

  const handleReadAloud = () => {
    const record = worldRecordsData[selectedRecord];
    const utterance = new SpeechSynthesisUtterance(
      `The ${selectedRecord} is ${record.name}. Details: ${record.details}. Place: ${record.place}. History: ${record.history}. Significance: ${record.significance}.`
    );
    speechSynthesis.speak(utterance);
    setReadAloud(true);
  };

  const record = worldRecordsData[selectedRecord];

  return (
    <div className="world-records">
      <h1>World Records Information</h1>
      <div>
        <label>
          Select Record:
          <select value={selectedRecord} onChange={handleRecordChange}>
            {Object.keys(worldRecordsData).map((record) => (
              <option key={record} value={record}>{record}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="info">
        <h2>{selectedRecord}</h2>
        <p><strong>Name:</strong> {record.name}</p>
        <p><strong>Details:</strong> {record.details}</p>
        <p><strong>Place:</strong> {record.place}</p>
        <p><strong>History:</strong> {record.history}</p>
        <p><strong>Significance:</strong> {record.significance}</p>
      </div>
      <button onClick={handleReadAloud}>Read Aloud</button>
    </div>
  );
};

export default WorldRecords;
